export const SETDICTIONARY = "SETDICTIONARY"; //设置字典
export const SETMEMBERTYPE = "SETMEMBERTYPE"; //设置会员类型
export const SETBRANCHS = "SETBRANCHS"; //单位
export const SETZHICHENG = "SETZHICHENG"; //职称
export const SETCITY = "SETCITY"; //城市
export const SETTOKEN = "SETTOKEN"; //access_token
export const SETREFRESHTOKEN = "SETREFRESHTOKEN"; //refresh_token
export const GROUP_TYPE = "GROUP_TYPE";
